var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Table, TableBody } from '@one-thd/sui-atomic-components';
import React, { Fragment, useEffect, useState } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { PHTableHeader, PHTableRow, PHTableSettingsDrawer } from './index';
import { PHTableHeaderValues } from './PHTableHeaderData';
import { TableSkeleton } from '../../shared/skeletons/TableSkeleton';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import AlertBanner from '../../shared/AlertBanner';
import { PHPagination } from '../PHPagination';
import NoOrdersView from '../NoOrdersView';
export var PHTable = function (_a) {
    var _b, _c, _d, _e, _f;
    var customerRole = _a.customerRole, customerType = _a.customerType, orderHistoryData = _a.orderHistoryData, orderHistoryLoaded = _a.orderHistoryLoaded, pHRequest = _a.pHRequest, setPHRequest = _a.setPHRequest, enableSettingsDrawer = _a.enableSettingsDrawer, setEnableSettingsDrawer = _a.setEnableSettingsDrawer;
    var _g = usePurchaseHistoryContext(), orderHistoryError = _g.orderHistoryError, alertState = _g.alertState, setAlertState = _g.setAlertState, setOpenAddReceiptDrawer = _g.setOpenAddReceiptDrawer;
    var _h = useState({ 0: 0 }), selected = _h[0], setSelected = _h[1];
    var _j = useState(0), key = _j[0], setKey = _j[1];
    var _k = useState(PHTableHeaderValues()), tableHeaderState = _k[0], setTableHeaderState = _k[1];
    useEffect(function () {
        setSelected({ 0: 0 });
    }, [pHRequest.pageNumber, pHRequest.sortBy, pHRequest.sortOrder]);
    var phData = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.lineItems);
    var isAdminRole = customerRole === 'ADMIN';
    var searchEnabled = pHRequest.searchBy !== undefined;
    var searchByObj = (_c = (_b = pHRequest === null || pHRequest === void 0 ? void 0 : pHRequest.searchBy) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : {};
    var isLineItemData = ['itemDescription'].includes((_d = Object.keys(searchByObj)) === null || _d === void 0 ? void 0 : _d[0]);
    var isPaymentColumnEnabled = (_e = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState.find(function (header) {
        return (header === null || header === void 0 ? void 0 : header.columnName) === 'Payment';
    })) === null || _e === void 0 ? void 0 : _e.enabled;
    // This is to fetch the order details and display the payment methods in the table after performing a search, if the payment column is enabled and the search is not done by item description.
    var fetchOrderDetailsAfterSearch = !isLineItemData && isPaymentColumnEnabled && searchEnabled;
    var totalNumberOfOrders = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.itemsCount) || 0;
    // This is to force the table to rerender since style changes weren't being applied on first render
    useEffect(function () {
        setKey(function (prevKey) { return prevKey + 1; });
    }, []);
    useEffect(function () {
        var _a;
        if (((_a = orderHistoryError === null || orderHistoryError === void 0 ? void 0 : orderHistoryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
            return;
        }
        if (orderHistoryError) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: 'Something went wrong on our end. Please check back later',
                status: 'error',
            });
        }
    }, [orderHistoryError]);
    var phTableAlertElement = function () {
        if (alertState) {
            return (React.createElement("div", { className: "sui-col-span-1" }, alertState && React.createElement(AlertBanner, __assign({}, alertState))));
        }
        return null;
    };
    if (orderHistoryLoaded &&
        (totalNumberOfOrders === 0 || ((_f = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _f === void 0 ? void 0 : _f.length) === 0)) {
        return (React.createElement(ErrorBoundary, { name: "no-orders" },
            React.createElement(NoOrdersView, { customerType: customerType, setOpenAddReceiptModal: setOpenAddReceiptDrawer })));
    }
    return (React.createElement("div", { className: "sui-overflow-x-scroll sui-mb-5", key: key },
        phTableAlertElement(),
        React.createElement(Table, { unlined: true, layout: "fixed", density: "loose", className: "sui-shadow-none" },
            React.createElement(PHTableHeader, { isAdminRole: isAdminRole, pHRequest: pHRequest, setPHRequest: setPHRequest, orderHistoryLoaded: orderHistoryLoaded, tableHeaderState: tableHeaderState }),
            React.createElement(TableBody, null, orderHistoryLoaded ? (phData === null || phData === void 0 ? void 0 : phData.map(function (order, index) { return (React.createElement(Fragment, { key: index },
                React.createElement(PHTableRow, { customerType: customerType, index: index, isAdminRole: isAdminRole, order: order, orderHistoryData: phData, pHRequest: pHRequest, searchEnabled: searchEnabled, selected: selected, setAlertState: setAlertState, setSelected: setSelected, tableHeaderState: tableHeaderState, fetchOrderDetailsAfterSearch: fetchOrderDetailsAfterSearch }))); })) : (React.createElement(TableSkeleton, null)))),
        React.createElement(ErrorBoundary, { name: "purchase-history-table-pagination" },
            React.createElement(PHPagination, null)),
        enableSettingsDrawer && (React.createElement(PHTableSettingsDrawer, { enableSettingsDrawer: enableSettingsDrawer, setEnableSettingsDrawer: setEnableSettingsDrawer, tableHeaderState: tableHeaderState, setTableHeaderState: setTableHeaderState }))));
};
